import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../ui/Button';

export const Hero: React.FC = () => {
    const scrollToSection = (id: string) => {
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <div className="relative min-h-screen w-full flex items-center justify-center bg-white overflow-hidden pb-20 pt-20 md:pt-20">
            {/* Background Image with Green Overlay */}
            <div className="absolute inset-0 z-0">
                <img 
                    src="./banner.jpeg" 
                    alt="Surgeon in operating theatre" 
                    className="w-full h-full object-cover"
                />
                {/* Primary color overlay at reduced opacity */}
                <div className="absolute inset-0 bg-[#11BC97]/0 mix-blend-multiply" />
                <div className="absolute inset-0 bg-gradient-to-b from-black/20 to-black/60" />
            </div>

            <div className="relative z-10 container mx-auto px-6 flex flex-col items-center text-center mt-10 md:mt-0">
                <motion.div 
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1, ease: "easeOut" }}
                    className="max-w-5xl"
                >
                    <div className="flex items-center justify-center gap-3 mb-6 md:mb-8">
                        <span className="hidden md:block h-[1px] w-12 bg-white/60"></span>
                        <span className="text-white font-bold tracking-[0.2em] uppercase text-xs md:text-sm backdrop-blur-sm px-4 py-1 rounded-full border border-white/20">
                            Cosmetic stature Lengthening 
                        </span>
                        <span className="hidden md:block h-[1px] w-12 bg-white/60"></span>
                    </div>
                    
                    <h1 className="text-4xl sm:text-5xl md:text-7xl font-bold text-white mb-6 md:mb-8 leading-[1.1] tracking-tight drop-shadow-xl">
                        Grow Taller.<br />
                        <span className="text-white/90">Go Lengthening.</span>
                    </h1>
                    
                    <p className="text-white/90 text-base md:text-2xl mb-10 md:mb-12 leading-relaxed max-w-3xl mx-auto font-light drop-shadow-md px-4">
                        World-class orthopedic specialists, state-of-the-art rehabilitation, and a personal guide for your entire journey.
                    </p>
                    
                    <div className="flex flex-col sm:flex-row gap-4 md:gap-6 justify-center w-full sm:w-auto px-6 sm:px-0">
                        {/* Fixed Button Colors */}
                        <Button 
                            onClick={() => scrollToSection('contact')}
                            className="w-full sm:w-auto px-8 md:px-10 py-4 md:py-5 text-base md:text-lg bg-[#11BC97] text-white hover:bg-[#0ea080] border border-[#11BC97] shadow-xl shadow-[#11BC97]/20"
                        >
                            Book a Free Consultation
                        </Button>
                        <Button 
                            onClick={() => scrollToSection('process')}
                            variant="outline" 
                            className="w-full sm:w-auto px-8 md:px-10 py-4 md:py-5 text-base md:text-lg border-white text-white hover:bg-transparent hover:text-[#11BC97] transition-colors backdrop-blur-sm"
                        >
                            Explore Our Process
                        </Button>
                    </div>
                </motion.div>
            </div>
        </div>
    );
};